<template>
  <div>
    <fieldset class="fieldset1">
      <legend class="text-black">
        <button type="button" class="btn btn-primary" @click="addCondition()">
          <i class="fa fa-plus"></i> {{ $t('approvalWorkFlow.addCondition') }}
        </button>
      </legend>
      <div class="condition-card">
        <fieldset class="fieldset2" v-for="(con, index) in conDatatable">
          <a
            class="legend2"
            href="#"
            v-show="conDatatable.length > 1"
            @click="conDelete(index, conDatatable[index])"
          >
            <i class="far fa-times-circle"></i>
          </a>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="col-sm-4 control-label required">{{
                  $t('approvalWorkFlow.conditionType')
                }}</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    v-model.number="conDatatable[index].cond_type_id"
                    @change="conditionTypeChange(index)"
                  >
                    <option
                      v-for="(conType, index) in conditionTypes"
                      :key="index"
                      :value="conType.cond_type_id"
                      >{{ conType.cond_type }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-4" v-if="conDatatable[index].cond_type_id != 0">
              <div class="form-group">
                <label class="col-sm-4 control-label required">{{
                  $t('approvalWorkFlow.operatorSign')
                }}</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    v-model="conDatatable[index].operator_sign"
                    @change="operatorSignChange(index)"
                  >
                    <option :value="null">{{ $t('select') }}</option>
                    <option
                      v-for="(appOperator, index) in operatorsByConditionTypes({
                        cond_type_id: conDatatable[index].cond_type_id
                      })"
                      :key="index"
                      :value="appOperator.sign"
                      >{{ appOperator.sign }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div
              class="col-md-4"
              v-if="
                conDatatable[index].cond_type_id != 0 &&
                  conDatatable[index].operator_sign != null &&
                  conDatatable[index].operator_sign != 'between'
              "
            >
              <div class="form-group">
                <label class="col-sm-4 control-label required">{{
                  $t('approvalWorkFlow.value')
                }}</label>
                <div class="col-sm-8">
                  <treeselect
                    v-if="conDatatable[index].operator_sign == 'in'"
                    :options="
                      valueOptions({
                        cond_type_id: conDatatable[index].cond_type_id
                      })
                    "
                    :multiple="true"
                    :limit="1"
                    :placeholder="$t('select')"
                    v-model="conDatatable[index].value1"
                    :maxHeight="150"
                  />
                  <treeselect
                    v-else
                    :options="
                      valueOptions({
                        cond_type_id: conDatatable[index].cond_type_id
                      })
                    "
                    :placeholder="$t('select')"
                    v-model="conDatatable[index].value1"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="row"
            v-if="
              conDatatable[index].cond_type_id != 0 &&
                conDatatable[index].operator_sign != null &&
                conDatatable[index].operator_sign == 'between'
            "
          >
            <div
              class="col-md-4"
              v-if="
                conDatatable[index].cond_type_id != 0 ||
                  conDatatable[index].operator_sign != null
              "
            >
              <div class="form-group">
                <label class="col-sm-4 control-label required">
                  {{ $t('approvalWorkFlow.value') }}
                  <span
                    v-show="conDatatable[index].operator_sign == 'between'"
                    >{{ $t('1') }}</span
                  >
                </label>
                <div class="col-sm-8">
                  <treeselect
                    v-if="conDatatable[index].operator_sign == 'in'"
                    :options="
                      valueOptions({
                        cond_type_id: conDatatable[index].cond_type_id
                      })
                    "
                    :multiple="true"
                    :limit="1"
                    :placeholder="$t('select')"
                    v-model="conDatatable[index].value1"
                    :maxHeight="150"
                  />
                  <treeselect
                    v-else
                    :options="
                      valueOptions({
                        cond_type_id: conDatatable[index].cond_type_id
                      })
                    "
                    :placeholder="$t('select')"
                    v-model="conDatatable[index].value1"
                    :maxHeight="150"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="col-sm-4 control-label required">{{
                  $t('approvalWorkFlow.value2')
                }}</label>
                <div class="col-sm-8">
                  <treeselect
                    :options="
                      valueOptions({
                        cond_type_id: conDatatable[index].cond_type_id
                      })
                    "
                    :placeholder="$t('select')"
                    v-model="conDatatable[index].value2"
                    :maxHeight="150"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <Details :index="index" v-model="conDatatable[index].details" />
          </div>
        </fieldset>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Details from './details.vue'

export default {
  name: 'condition-detail',
  props: {
    value: {}
  },
  components: { Details },

  data() {
    return {
      deleting: false,
      conDatatable: [],
      conItem: {
        app_cond_id: 0,
        app_flow_id: '',
        cond_type_id: 0,
        operator_sign: null,
        value1: null,
        value2: null,
        details: []
      }
    }
  },

  computed: {
    ...mapState('approvalWorkFlow', [
      'conditionTypes',
      'approvalOperators',
      'edit_data'
    ]),
    ...mapGetters('approvalWorkFlow', [
      'operatorsByConditionTypes',
      'valueOptions'
    ])
  },

  created() {},

  methods: {
    ...mapActions('approvalWorkFlow', ['save', 'conDestroy']),

    async conDelete(index, item) {
      if (item.app_cond_id === 0) {
        this.conDatatable.splice(index, 1)
        return
      }
      this.deleting = true

      await this.$store
        .dispatch('approvalWorkFlow/deleteCondition', item.app_cond_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.deleting = false
          this.conDatatable.splice(index, 1)
        })
        .catch(error => {
          this.deleting = false
          this.$toasted.error(error.message)
        })
    },

    addCondition() {
      this.conDatatable.push({
        app_cond_id: 0,
        app_flow_id: this.edit_data.app_flow_id,
        cond_type_id: 0,
        operator_sign: null,
        value1: null,
        value2: null,
        details: []
      })
    },
    conditionTypeChange(index) {
      this.conDatatable[index].operator_sign = null
      this.conDatatable[index].value1 = null
      this.conDatatable[index].value2 = null
    },
    operatorSignChange(index) {
      this.conDatatable[index].value1 = null
      this.conDatatable[index].value2 = null
    },

    pushToConDatatable() {
      this.value.forEach(data => {
        let detail = Object.assign({}, this.newItem, data, {
          app_cond_id: data.app_cond_id,
          app_flow_id: data.app_flow_id,
          cond_type_id: data.cond_type_id,
          operator_sign: data.operator_sign,
          value1: this.getList(data.value1),
          value2: data.value2,
          details: data.details
        })

        this.$nextTick(() => {
          this.conDatatable.push(detail)
        })
      })
    },
    getList(item) {
      if (item === null || item === undefined || item === '') {
        return ''
      }
      return item.split('^').map(Number)
    }
  },
  watch: {
    value: {
      handler(val) {
        if (_.isEqual(val, this.conDatatable)) return

        this.pushToConDatatable()
      },
      deep: true,
      immediate: true
    },

    conDatatable: {
      handler(val) {
        if (_.isEqual(val, this.value)) return

        this.$emit('input', val)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
/* customize fieldset style */
fieldset {
  border: 1px solid #ececec;
  border-radius: 4px;
  z-index: 0;
}
.condition-card {
  max-height: 60vh;
  overflow-y: scroll;
}

fieldset legend {
  padding: 0;
  width: auto;
  border-radius: 7px;
  font-size: 14px;
  box-shadow: -1px 4px 27px -7px #bdbdbd;
  background: #fffdfd;
}

fieldset {
  z-index: 0;
  position: relative;
  margin-bottom: 30px;
  margin-top: 2px;
  border-radius: 4px;
}
.fieldset2 {
  border: 1px solid #17a2b8;
}
.fieldset1 {
  min-height: 40vh;
  border: 2px solid #007bff;
}
.legend2 {
  position: absolute;
  top: -0.2em;
  right: -1px;
  background: #fff;
  line-height: 1.2em;
  width: auto;
  border-radius: 7px;
  font-size: 14px;
  color: red;
  font-size: 20px;
  box-shadow: -1px 4px 27px -7px #bdbdbd;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
</style>
